import { render, staticRenderFns } from "./homeOrderPay.vue?vue&type=template&id=cf8a0252&scoped=true"
import script from "./homeOrderPay.vue?vue&type=script&lang=js"
export * from "./homeOrderPay.vue?vue&type=script&lang=js"
import style0 from "./homeOrderPay.vue?vue&type=style&index=0&id=cf8a0252&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8a0252",
  null
  
)

export default component.exports